{
  "Sidebar.boards": "Boards",
  "Sidebar.members": "Members",
  "Sidebar.settings": "Settings",
  "Sidebar.billing": "Billing",
  "Sidebar.apiTokens": "API Tokens",
  "Sidebar.webhooks": "Webhooks",
  "Sidebar.allWorkspaces": "All Workspaces",
  "Sidebar.newWorkspace": "New workspace",
  "Sidebar.createFirst": "+ Create your first workspace",
  "Sidebar.logout": "Log out",
  "Sidebar.unknownUser": "Unknown",
  "WorkspaceListPage.title": "Workspaces",
  "WorkspaceListPage.newButton": "+ New Workspace",
  "WorkspaceListPage.loading": "Loading workspaces…",
  "WorkspaceListPage.emptyTitle": "No workspaces yet",
  "WorkspaceListPage.emptyBody": "Create a workspace to organise your boards and invite your team.",
  "WorkspaceListPage.emptyAction": "Create your first workspace",
  "WorkspaceListPage.createdAt": "Created",
  "WorkspaceListPage.openButton": "Open",
  "CreateWorkspaceModal.title": "Create workspace",
  "CreateWorkspaceModal.description": "Give your workspace a name to get started.",
  "CreateWorkspaceModal.nameLabel": "Workspace name",
  "CreateWorkspaceModal.namePlaceholder": "e.g. Acme Corp",
  "CreateWorkspaceModal.submitButton": "Create workspace",
  "CreateWorkspaceModal.submitting": "Creating…",
  "CreateWorkspaceModal.cancelButton": "Cancel",
  "CreateWorkspaceModal.errorGeneric": "Failed to create workspace. Please try again.",
  "CreateWorkspaceModal.errorUpgradeAllOwnedWorkspaces": "You can only create more workspaces after upgrading your plan.",
  "CreateWorkspaceModal.upgradeWorkspaceLink": "Go to billing",
  "WorkspacePage.title": "Workspace",
  "WorkspacePage.headingTitle": "Workspace Settings",
  "WorkspacePage.membersHeading": "Members",
  "WorkspacePage.inviteButton": "Invite Member",
  "WorkspacePage.noWorkspace": "No workspace selected.",
  "WorkspacePage.loading": "Loading workspace…",
  "WorkspacePage.errorGeneric": "Something went wrong. Please try again.",
  "WorkspaceSwitcher.label": "Switch workspace",
  "WorkspaceSwitcher.noWorkspaces": "No workspaces",
  "WorkspaceSwitcher.loading": "Loading…",
  "InviteMemberModal.title": "Invite Member",
  "InviteMemberModal.emailLabel": "Email address",
  "InviteMemberModal.emailPlaceholder": "member@example.com",
  "InviteMemberModal.roleLabel": "Role",
  "InviteMemberModal.submitButton": "Send Invite",
  "InviteMemberModal.cancelButton": "Cancel",
  "InviteMemberModal.successMessage": "Invite sent successfully.",
  "InviteMemberModal.errorInsufficientRole": "You don't have permission to invite members.",
  "InviteMemberModal.errorGeneric": "Failed to send invite. Please try again.",
  "MemberList.roleHeader": "Role",
  "MemberList.emailHeader": "Email",
  "MemberList.actionsHeader": "Actions",
  "MemberList.removeButton": "Remove",
  "MemberList.changeRoleButton": "Change Role",
  "MemberList.removeConfirmTitle": "Remove member?",
  "MemberList.removeConfirmBody": "Are you sure you want to remove this member from the workspace?",
  "MemberList.removeConfirmYes": "Remove",
  "MemberList.removeConfirmNo": "Cancel",
  "MemberList.errorLastOwner": "Cannot remove the last owner of the workspace.",
  "MemberList.errorInsufficientRole": "You don't have permission to manage members.",
  "MemberList.errorGeneric": "Action failed. Please try again.",
  "MemberList.empty": "No members found.",
  "RoleBadge.OWNER": "Owner",
  "RoleBadge.ADMIN": "Admin",
  "RoleBadge.MEMBER": "Member",
  "RoleBadge.VIEWER": "Viewer",
  "AcceptInvitePage.title": "Accept Invite",
  "AcceptInvitePage.loading": "Validating invite…",
  "AcceptInvitePage.accept": "Accept Invitation",
  "AcceptInvitePage.successMessage": "You have joined the workspace.",
  "AcceptInvitePage.errorExpired": "This invite has expired.",
  "AcceptInvitePage.errorAlreadyUsed": "This invite has already been used.",
  "AcceptInvitePage.errorGeneric": "Failed to accept invite. Please try again.",
  "AcceptInvitePage.inviteInfo": "You have been invited to join {workspaceName} as {role}.",
  "Sidebar.ariaNavLabel": "Sidebar",
  "Sidebar.searchAriaLabel": "Search (⌘K)",
  "Sidebar.searchLabel": "Search",
  "Sidebar.inviteExternalUserAria": "Invite External User"
}